import { useRouteMatch } from 'react-router-dom';

import { SidebarLayout } from '@treams/treams-ui';

import {
	useGrowthPathJobTitleCompetenciesQuery,
	useGrowthPathUserCompetenciesQuery,
} from '../growth-path/hooks/useGrowthPathScale';
import Competencies from './Competencies';
import { CompetenciesSidebar } from './CompetenciesSidebar';
import {
	isOwnedJobTitle,
	skillsAnalysisFromJobTitle,
	skillsAnalysisFromUser,
} from './SkillsAnalysis';

function UserCatalogCompetencies(props: { jobTitleID: string; userID: string }) {
	const query = useGrowthPathJobTitleCompetenciesQuery({
		id: props.jobTitleID,
		userID: props.userID,
	});

	if (!query.data) {
		return <Competencies.Skeleton />;
	}

	return (
		<Competencies
			skillsAnalysis={skillsAnalysisFromJobTitle(query.data.jobTitle as any, query.scale)}
		/>
	);
}

function UserCompetenciesSidebar(props: { userID: string }) {
	const query = useGrowthPathUserCompetenciesQuery({ id: props.userID });

	if (!query.data) {
		return <CompetenciesSidebar.Skeleton />;
	}

	return <CompetenciesSidebar user={query.data.user as any} />;
}

function UserCompetenciesFactory(props: { userID: string; jobTitleID: string }) {
	const query = useGrowthPathUserCompetenciesQuery({ id: props.userID });

	if (!query.data) {
		return <Competencies.Skeleton />;
	}

	return isOwnedJobTitle(query.data.user as any, props.jobTitleID) ? (
		<Competencies
			owned
			skillsAnalysis={skillsAnalysisFromUser(query.data.user as any, props.jobTitleID, query.scale)}
		/>
	) : (
		<UserCatalogCompetencies jobTitleID={props.jobTitleID} userID={query.data.user.id} />
	);
}

export default function UserCompetencies() {
	const { params } = useRouteMatch<{ id: string; jobTitleID: string }>();

	return (
		<SidebarLayout sidebar={<UserCompetenciesSidebar userID={params.id} />}>
			<UserCompetenciesFactory userID={params.id} jobTitleID={params.jobTitleID} />
		</SidebarLayout>
	);
}
